import React, { createContext} from "react";

  const AuthUser = createContext();
  export default AuthUser;